'use client';

import { useState } from 'react';
import { useTourStore } from '@eliadmin/core/src/stores/tours-store';
import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { TourSidebarFilterLabel } from '../tour-sidebar-filter-label';
import { fetchTravelAgencyAttributeValues } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';
import { useQuery } from '@tanstack/react-query';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const TourSidebarFilterEquipment = () => {
  const { filter, setFilter } = useTourStore();
  const [showCount, setShowCount] = useState(6);
  const locale = useLocaleStore(state => state.currentLocale);
  const { t } = useTranslations();

  const { data: attributes } = useQuery({
    queryKey: ['travel_agency_attributes_equipment'],
    queryFn: async () => {
      return await fetchTravelAgencyAttributeValues({ locale, attributeId: 2 }).then(res =>
        res.data.map(item => {
          return { label: item.name, value: item.id.toString() };
        }),
      );
    },
  });

  const handleCheckedChange = (value: string) => {
    const currentEquipment = filter.values || [];
    const updatedValues = currentEquipment.includes(value)
      ? currentEquipment.filter(item => item !== value) // Remove if already checked
      : [...currentEquipment, value]; // Add if not checked

    setFilter({
      ...filter,
      values: updatedValues,
    });
  };

  const filteredEquipment = attributes ?? [];

  // Reset showCount if fewer than 6 items
  const displayedEquipment = filteredEquipment.slice(0, showCount);
  if (filteredEquipment.length <= 6 && showCount > 6) {
    setShowCount(6);
  }

  return (
    <div className="text-sm">
      <TourSidebarFilterLabel label={t('text1399')} />
      <div className="mt-4 flex flex-col gap-2">
        {displayedEquipment.map(item => (
          <div key={item.value} className="flex items-center gap-2">
            <Checkbox
              id={item.value}
              value={item.value}
              checked={(filter.values || []).includes(item.value)}
              onCheckedChange={() => handleCheckedChange(item.value)}
              className="rounded-[4px] data-[state=checked]:bg-primary"
            />
            <label htmlFor={item.value} className="cursor-pointer select-none text-gray-800">
              {item.label}
            </label>
          </div>
        ))}
        {filteredEquipment.length > showCount && (
          <p
            onClick={() => setShowCount(showCount + 5)}
            className="mt-2 cursor-pointer text-primary"
          >
            + {t('text1856')}
          </p>
        )}
      </div>
    </div>
  );
};
